export default "__VITE_ASSET__C7FTS6Y9__"